<div class="form-group" [formGroup]="formGroup">
    <wdx-form-field
        [label]="'WORKFLOW_QUERY_VIEW_LABEL' | translateTokenisedString"
        [isRequired]="false"
        labelForId="viewCode"
        [formGroup]="formGroup"
        class="d-block mb-4"
    >
        <ng-select
            [items]="views$ | ngrxPush"
            formControlName="viewCode"
            id="viewCode"
            bindLabel="name"
            (change)="onViewCodeChanged($event)"
        >
            <ng-template ng-option-tmp ng-label-tmp let-item="item">
                {{ item.name | translateTokenisedString }}
            </ng-template>
        </ng-select>
        <h6 class="pt-1">
            {{ 'WORFLOW_QUERY_VIEW_MESSAGE' | translateTokenisedString }}
        </h6>
    </wdx-form-field>
    <wdx-form-field
        [label]="'WORKFLOW_QUERY_DESCRIPTION_LABEL' | translateTokenisedString"
        [isRequired]="false"
        labelForId="queryDescription"
        [formGroup]="formGroup"
        class="d-block mb-4"
    >
        <textarea
            wdxInputText
            cols="30"
            rows="4"
            formControlName="queryDescription"
            id="queryDescription"
        ></textarea>
    </wdx-form-field>
    <wdx-form-field
        [label]="'WORKFLOW_QUERY_EXCLUSION_PERIOD' | translateTokenisedString"
        [isRequired]="false"
        labelForId="exclusionPeriod"
        [formGroup]="formGroup"
        class="d-block mb-4"
    >
        <input
            wdxInputText
            currencyMask
            type="text"
            inputmode="numeric"
            autocomplete="off"
            class="form-control"
            formControlName="exclusionPeriod"
            id="exclusionPeriod"
            [options]="integerMaskNumberConfigOverride"
        />
    </wdx-form-field>

    <wdx-form-field
        [label]="'WORKFLOW_QUERY_JSON_LABEL' | translateTokenisedString"
        [isRequired]="true"
        labelForId="query"
        [formGroup]="formGroup"
        class="d-block mb-4"
    >
        <wdx-json-editor
            formControlName="query"
            [customInputHandler]="customInputHandler"
            [customOutputHandler]="customOutputHandler"
        >
        </wdx-json-editor>
    </wdx-form-field>
</div>
